import React, { useEffect, useState } from "react";
import {ListUserBonusRequest, BonusOffer, UserBonusEvent} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {UserBonusStatus, UserBonusView} from "../../http/protocol";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {ColumnType} from "../list/list/ColumnType";
import {ActionType} from "../list/list/DataTable";
import {UserBonusService} from "../../services/UserBonusService";
import {ListUtils} from "../list/list/ListUtils";
import {PagerModel} from "../list/list/PagerModel";

interface State  {
    bonusOffers: UserBonusView[],
    listRequest? : ListUserBonusRequest;
}

interface Props {
    userId:number
}

const UserBonusHistory: React.FC<Props> = (props: Props) => {
    const bonusService = getContainer().getUserBonusService();
    const [bonusOffers, setBonusOffers] = useState([]);
    const [userId, setUserId] = useState(props.userId);
    const [bonusList, setBonusList] = useState([]);
    //when url location has #user-bonus-history, expand the box
    const [lookupExpanded, setLookupExpanded] = useState(window.location.hash === "#user-bonus-history");
    const [listRequest, setListRequest] = useState<ListUserBonusRequest>({ userId : props.userId, limit : 10, offset: 0, orderBy : "timestamp", ascending: false});
    const columns = [
        { property : "id", name : "ID" },
        { property : "timestamp", name : "Created", type : ColumnType.DATE},
        { property : "bonusConfig.name", name : "Name",type:  ColumnType.LINK, getUrl : (item : BonusOffer) => { return item.bonusConfig ? "/bonus/config/"+item.bonusConfig.id : false}},
        { property : "status", name : "Status"},
        { property : "currentTurnover", name : "Current Turnover"},
        { property : "turnoverRequirement", name : "Turnover Requirement"},
        { property : "totalBonusAmount", name : "Amount"},
        { property : "bonusOfferId", name : "Offer Id", type: ColumnType.LINK, getUrl : (item : UserBonusView) => { return item ? "/bonus/offer/"+item.bonusOfferId : false}},
        { property : "currentTotalPayouts", name : "Payout #"},
        { property : "currentPayoutAmount", name : "Paid"}
    ];

    const actions = [
        //the bonus does not have a bonus offer id
        { id : "refresh", name : "Refresh", className : "btn btn-primary", iconClassName : "fa fa-sync", type : undefined, optional : (item : any) => item.status !== UserBonusStatus.RUNNING },
        { id : "view", name : "View", className : "btn btn-primary", type : ActionType.LINK, getLink : (item : any) => "/user-bonus/"+item.id+"/user/"+userId },
        //{ id : "cancel", name : "Cancel", className : "btn btn-danger", iconClassName : "fa fa-times", type : ActionType.CANCEL, optional : (item : any) => item.status === UserBonusStatus.RUNNING },
        //{ id : "cancelWithPayout", name : "Cancel with payout", className : "btn btn-danger", iconClassName : "fa fa-times", type : ActionType.CANCEL, optional : (item : any) => item.status === UserBonusStatus.RUNNING }
    ];

    const pagerChanged = (pager : PagerModel) => {
        if(!listRequest) {
            return;
        }
        var listRequestNew = ListUtils.toListRequest<ListUserBonusRequest>(listRequest, pager);
        setListRequest(listRequestNew);
    }

 
    const onAction = (item : UserBonusView, action : string):Promise<UserBonusView | void> | undefined => {
        if(action==="cancel"){
            userId !== undefined && item.id && bonusService.cancelUserBonus(userId, item.id).then(() => {
                document.location.reload();
            })
        }
        if(action==="cancelWithPayout"){
            userId !== undefined && item.id && bonusService.cancelUserBonusWithPayout(userId, item.id)
            .then(() => {
                document.location.reload();
            })
        }
        if(action==="refresh" && item.id){
            return bonusService.getEntity(item.id.toString());
        }
        return undefined;
    }

    const getData = async (id:any) => {
        let request = { userId : id, limit : 10, offset: 0, orderBy : "timestamp", ascending: false}
        await bonusService.list(request)
        .then((data:any) => {
            setBonusList(data);
         })
         .catch(e=>{
           console.error("Error gettting bonus list endpoint");
         }); 
    }

    useEffect(() => {
        const handleLocationChange = () => {
            setLookupExpanded(window.location.hash === "#user-bonus-history");
        }
        window.addEventListener("hashchange", handleLocationChange);
        return () => {
            window.removeEventListener("hashchange", handleLocationChange);
        }
    },[]);

    useEffect(() => {
        setUserId(props.userId);
        getData(userId);
    },[props.userId]);

        return(
            <div className="col-lg-12" id={"user-bonus-history"}>
            <div className={"card-box expandable-box"}  style={!lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !lookupExpanded ? setLookupExpanded(true) : null}>
            {lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); setLookupExpanded(false);}}><i className="mdi mdi-minus"></i></a>
                )}
                {!lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault();setLookupExpanded(true);}}><i className="mdi mdi-plus"></i></a>
                )}
                    <div className="" onClick={()=>setLookupExpanded (!lookupExpanded)}>
                        <h4>Bonus History</h4>
                    </div>
                    {lookupExpanded && ( <EntityDataTable
                        service={bonusService}
                        listRequest={listRequest}
                        columns={columns}
                        onPagerChange={pagerChanged.bind(this)}
                        onAction={onAction.bind(this)}
                        actions={actions}
                    />
                    )}
                </div>
            </div>
        )
    }

export default UserBonusHistory;
